import { twMerge } from 'tailwind-merge';

import { Button } from '../../../Clickables/Buttons/Button';
import { ChevronLeftIcon } from '../../../Icons/ChevronLeftIcon';
import { Text } from '../../../Text/Text';

interface NavigationBarProps {
  className?: string;
  locationName: string;
  onClick: () => void;
}

export const NavigationBar = ({
  className,
  locationName,
  onClick: handleOnClick,
}: NavigationBarProps) => {
  return (
    <nav className={twMerge('z-modal border-twilight sticky top-0 border-b bg-white', className)}>
      <Button
        className="text-trench flex items-center gap-x-4 px-2 py-3 sm:px-8 md:px-1"
        onClick={handleOnClick}
        size="none"
        variant="textPrimarySans"
      >
        <ChevronLeftIcon />
        <Text className="m-0 font-semibold">{locationName}</Text>
      </Button>
    </nav>
  );
};
